<micro-select-combo #sel
              placeholder="Phase"
              [mode]="mode"
              [(id)]="taskPhaseId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="isDisabled()"
              [requires]="requires()"
              platformService="taskd"
>
</micro-select-combo>
